import { render, staticRenderFns } from "./AssessmentRule.vue?vue&type=template&id=66d66b0f"
import script from "./AssessmentRule.vue?vue&type=script&lang=js"
export * from "./AssessmentRule.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports